<div class="note">
  <div class="note_toolbar">
    <span [ngClass]="firstElement == 0 ? 'marginBottom' : ''" class="close material-icons" (click)="onDismiss($event)"
      style="text-transform: none !important;">{{firstElement > 0 ? 'close' : ''}}</span>
  </div>
  <div class="content" [ngClass]="firstElement == 0 ? 'style' : ''" [attr.contenteditable]="!isAccessRead && !roleForFacility ? 'true' : 'false'" (blur)="onFocusOut($event)" (paste)="onPaste($event)">
    <ng-content></ng-content>
  </div>

</div>
